import { useLocation, useNavigate } from 'react-router-dom';
import {
  Authenticator,
  Heading,
  useTheme,
  View,
  Image,
  Text,
  useAuthenticator,
} from '@aws-amplify/ui-react';
import { useEffect } from 'react';
import logo from '../assets/logo-feebbo-tools.svg';

const components = {
  Header() {
    const { tokens } = useTheme();

    return (
      <View textAlign="left" padding={tokens.space.small}>
        <Image alt="Feebbo logo" src={logo} />
      </View>
    );
  },

  Footer() {
    const { tokens } = useTheme();

    return (
      <View textAlign="center" padding={tokens.space.large}>
        <Text color={tokens.colors.white}>&copy; Copyright Feebbo Digital. All Rights Reserved</Text>
      </View>
    );
  },

  SignIn: {
    Header() {
      // const { tokens } = useTheme();

      return (
        <Heading padding={"2rem 0 0 0"} level={3} textAlign={'center'}>
          Sign in to your account
        </Heading>
      );
    },
    Footer() {
      const { toForgotPassword } = useAuthenticator();

      return (
        <View textAlign="center">
          <button onClick={toForgotPassword} className="btn btn-link custom-hover">
            ¿Olvidaste tu contraseña?
          </button>
        </View>
      );
    },
  },
};

const formFields = {
  signIn: {
    username: {
      label: 'Email',
      placeholder: 'Enter your email',
      isRequired: true,
      order: 1,
    },
    password: {
      label: 'Password',
      placeholder: 'Enter your password',
      isRequired: true,
      order: 2,
    },
  },
};

export default function Login() {
  const { route } = useAuthenticator((context) => [context.route]);
  const location = useLocation();
  const navigate = useNavigate();
  const from = (location.state as any)?.from?.pathname || '/';

  useEffect(() => {
    if (route === 'authenticated') {
      navigate(from, { replace: true });
    }
  }, [route, navigate, from]);

  return <Authenticator formFields={formFields} components={components} hideSignUp={true} />;
}
